import { GetStockItem4TransferFGResult, TransferFGSearch } from './../model/stock-transfer-serial.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { User } from '../model/user.model';
import { DisposalSearch, DisposalHeader } from '../model/disposal.model';


const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class DisposalService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/disposal';

    }


    GetNGdata4DPSProcess(search: DisposalSearch): Observable<DisposalHeader[]> {
        return this.http.post<DisposalHeader[]>(this.Url + "/GetNGdata4DPSProcess", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetNGdata4DPSListResult(search: DisposalSearch): Observable<DisposalHeader[]> {
        return this.http.post<DisposalHeader[]>(this.Url + "/GetNGdata4DPSListResult", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    AddDisposal(data: DisposalHeader): Observable<any> {
        return this.http.post<any>(this.Url + "", data, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    GetNGdata4DPSListForExport(search: DisposalSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetNGdata4DPSListForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            //catchError(this.handleError<StockTransferOrderSearch>('SearchWorkPermit'))
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/services/disposal.service.ts